import React from 'react';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import Playlist from '../playlist/Playlist';

// A own playlist can be from LINK / Local
// && merge with some infos YD that LINK does have.
function ConnectedPlaylistRoute({ isConnected, storePlaylists }) {
  return (
    <Switch>
      <Route path={[`/playlists/:id/:key`, `/playlists/:id`]} render={ props => {
        const playlist = (storePlaylists && storePlaylists.get) ? storePlaylists.get(props.match.params.id) : null;
        let params = {};
        if (playlist) {
          params = {
            name: playlist.name,
            track_count: playlist.track_count,
            length_ms: playlist.length_ms,
            covers: playlist.covers ?? null,
            fromDJ: playlist.fromDJ ?? null,
          }
        }

        return <Playlist key={props.match.params.key} {...params} type={`playlists`}
          path={(isConnected) ? `/my/playlists/${props.match.params.id}` : null}
          data={ (!isConnected && playlist) ? playlist : null }
          propertyUpdatedDate={`updated_date`}
          propertyCreatedDate={`created_date`}
        />
      }} />
    </Switch>
  );
}

const PlaylistRoute = connect(
  state => ({
    isConnected: state.isConnected,
    storePlaylists: state.storePlaylists,
  })
)(ConnectedPlaylistRoute);

export default PlaylistRoute;
